/**
 * List Schema of CargaCorreios
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CargaCorreios} from '@/model/resource/CargaCorreios'

/* TODO: review generated schema */
export class ListCargaCorreiosSchema extends Schema {
  readonly name = 'ListCargaCorreios'

  readonly fieldSet: FieldSet<CargaCorreios> = {
    idCargaCorreiosPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    cdCorreios: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
